/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const buildScopedCustomCss = (scopeSelector, cssText) => {
  if (!cssText || typeof cssText !== 'string') return '';
  const declarations = cssText.split('}');
  let output = '';
  for (let i = 0; i < declarations.length; i++) {
    const declaration = declarations[i];
    if (!declaration) continue;
    const trimmed = declaration.trim();
    if (!trimmed) continue;
    output += `${scopeSelector} ${trimmed} }\n`;
  }
  return output;
};

Shopify.theme.jsFeaturedCollections = {
  init: function ($section) {
    Shopify.theme.jsFeaturedCollections = $.extend(this, Shopify.theme.getSectionData($section));

    const sectionData = Shopify.theme.getSectionData($section);
    const sectionId = sectionData.id;

    const state = {
      instances: new Map(),
      activePanelId: null,
      customCssEl: null,
      customVisibilityEl: null,
      sectionId
    };
    $section.data('mxFeaturedCollections', state);

    this.applyRuntimeStyles($section);
    this.bindEvents($section);

    const $initialPill = $section.find('[data-mx-featured-collections-pill][aria-selected="true"]').first();
    const panelId = $initialPill.length
      ? $initialPill.attr('data-panel-id')
      : $section.find('[data-mx-featured-collections-pill]').first().attr('data-panel-id');

    if (panelId) {
      this.activatePanel($section, panelId);
    }
  },

  applyRuntimeStyles: function ($section) {
    const sectionData = Shopify.theme.getSectionData($section);
    const sectionId = sectionData.id;

    if (typeof sectionData.padding_top === 'number') {
      $section.css('padding-top', `${sectionData.padding_top}px`);
    }
    if (typeof sectionData.padding_bottom === 'number') {
      $section.css('padding-bottom', `${sectionData.padding_bottom}px`);
    }

    const $root = $section.find('[data-mx-featured-collections]').first();
    if (!$root.length) return;

    if (sectionData.background_style) {
      $root.css('background', sectionData.background_style);
    }
    if (typeof sectionData.border_radius === 'number') {
      $root.css('border-radius', `${sectionData.border_radius}px`);
    }

    if (typeof sectionData.border_width === 'number' && sectionData.border_width > 0) {
      $root.css('border-width', `${sectionData.border_width}px`);
      $root.css('border-style', sectionData.border_style || 'solid');
      $root.css('border-color', sectionData.border_color || '#000000');
    } else {
      $root.css('border-width', '');
      $root.css('border-style', '');
      $root.css('border-color', '');
    }

    $root[0].style.setProperty('--mx-cta-bg', sectionData.cta_background_color || '#000000');
    $root[0].style.setProperty('--mx-cta-text', sectionData.cta_text_color || '#ffffff');
    $root[0].style.setProperty('--mx-heading-color', sectionData.heading_color || '#000000');
    $root[0].style.setProperty('--mx-heading-weight', sectionData.heading_font_weight || 'normal');
    $root[0].style.setProperty('--mx-heading-transform', sectionData.heading_text_transform || 'none');
    $root[0].style.setProperty('--mx-heading-bg', sectionData.heading_background_color || '#000000');
    $root[0].style.setProperty('--mx-heading-br', `${sectionData.heading_background_border_radius || 0}px`);
    $root[0].style.setProperty('--mx-pill-border-style', sectionData.pill_border_style || 'solid');
    $root[0].style.setProperty('--mx-pill-border-width', `${typeof sectionData.pill_border_width === 'number' ? sectionData.pill_border_width : 1}px`);
    $root[0].style.setProperty('--mx-pill-border-color', sectionData.pill_border_color || '#000000');
    $root[0].style.setProperty('--mx-pill-border-style-active', sectionData.pill_border_style_active || sectionData.pill_border_style || 'solid');
    $root[0].style.setProperty('--mx-pill-border-width-active', `${typeof sectionData.pill_border_width_active === 'number' ? sectionData.pill_border_width_active : (typeof sectionData.pill_border_width === 'number' ? sectionData.pill_border_width : 1)}px`);
    $root[0].style.setProperty('--mx-pill-border-color-active', sectionData.pill_border_color_active || sectionData.pill_border_color || '#000000');
    $root[0].style.setProperty('--mx-pill-bg', sectionData.pill_bg_color || '#ffffff');
    $root[0].style.setProperty('--mx-pill-bg-hover', sectionData.pill_bg_color_hover || '#f3f4f6');
    $root[0].style.setProperty('--mx-pill-bg-active', sectionData.pill_bg_color_active || 'rgba(0, 0, 0, 0.08)');
    $root[0].style.setProperty('--mx-pill-text-color', sectionData.pill_text_color || '#111827');
    $root[0].style.setProperty('--mx-pill-text-size', sectionData.pill_text_size || '0.875rem');
    $root[0].style.setProperty('--mx-pill-text-weight', sectionData.pill_text_weight || '500');
    $root[0].style.setProperty('--mx-pill-text-color-active', sectionData.pill_text_color_active || sectionData.pill_text_color || '#111827');
    $root[0].style.setProperty('--mx-pill-text-weight-active', sectionData.pill_text_weight_active || '700');
    $root[0].style.setProperty('--mx-pill-cursor', sectionData.pill_cursor || 'pointer');

    if (sectionData.line_clamp === true) {
      $root.addClass('mx-line-clamp');
      const clampQty = typeof sectionData.line_clamp_quantity === 'number' ? sectionData.line_clamp_quantity : 2;
      $root[0].style.setProperty('--mx-line-clamp', clampQty);
    } else {
      $root.removeClass('mx-line-clamp');
    }

    if (sectionData.enable_box_shadow === true) {
      $root.addClass('mx-box-shadow');
    } else {
      $root.removeClass('mx-box-shadow');
    }

    if (sectionData.enable_price_customization === true) {
      $root.addClass('mx-price-custom');
      if (typeof sectionData.price_font_weight === 'number') {
        $root[0].style.setProperty('--mx-price-weight', sectionData.price_font_weight);
      }
      if (typeof sectionData.price_font_size === 'number') {
        $root[0].style.setProperty('--mx-price-size', `${sectionData.price_font_size}rem`);
      }
      if (sectionData.price_font_color) {
        $root[0].style.setProperty('--mx-price-color', sectionData.price_font_color);
      }
    } else {
      $root.removeClass('mx-price-custom');
    }

    const scopeSelector = `#shopify-section-${sectionId} [data-mx-featured-collections]`;
    const customCss = buildScopedCustomCss(scopeSelector, sectionData.custom_css);

    const existingCustomCssEl = document.getElementById(`mx-featured-collections-custom-css-${sectionId}`);
    if (existingCustomCssEl) existingCustomCssEl.remove();

    if (customCss) {
      const styleEl = document.createElement('style');
      styleEl.id = `mx-featured-collections-custom-css-${sectionId}`;
      styleEl.type = 'text/css';
      styleEl.appendChild(document.createTextNode(customCss));
      document.head.appendChild(styleEl);

      const state = $section.data('mxFeaturedCollections');
      if (state) state.customCssEl = styleEl;
    }

    const existingVisibilityEl = document.getElementById(`mx-featured-collections-visibility-${sectionId}`);
    if (existingVisibilityEl) existingVisibilityEl.remove();

    const cssClass = sectionData.css_class || '';
    let visibilityCss = '';
    if (cssClass.indexOf('is-hidden-desktop-only') >= 0) {
      visibilityCss += `@media only screen and (min-width: 481px) { #shopify-section-${sectionId} { display: none; } }\n`;
    }
    if (cssClass.indexOf('is-hidden-mobile-only') >= 0) {
      visibilityCss += `@media only screen and (max-width: 480px) { #shopify-section-${sectionId} { display: none; } }\n`;
    }

    if (visibilityCss) {
      const styleEl = document.createElement('style');
      styleEl.id = `mx-featured-collections-visibility-${sectionId}`;
      styleEl.type = 'text/css';
      styleEl.appendChild(document.createTextNode(visibilityCss));
      document.head.appendChild(styleEl);

      const state = $section.data('mxFeaturedCollections');
      if (state) state.customVisibilityEl = styleEl;
    }
  },

  bindEvents: function ($section) {
    const self = this;
    $section.off('.mxFeaturedCollections');

    $section.on('click.mxFeaturedCollections', '[data-mx-featured-collections-pill]', function () {
      const panelId = $(this).attr('data-panel-id');
      if (!panelId) return;
      self.activatePanel($section, panelId);
    });

    $section.on('click.mxFeaturedCollections', '.js-featured-collection-prev', function () {
      const instance = self.getActiveFlickityInstance($section);
      if (instance) instance.previous();
    });

    $section.on('click.mxFeaturedCollections', '.js-featured-collection-next', function () {
      const instance = self.getActiveFlickityInstance($section);
      if (instance) instance.next();
    });
  },

  getActiveFlickityInstance: function ($section) {
    const state = $section.data('mxFeaturedCollections');
    if (!state || !state.activePanelId) return null;
    const entry = state.instances.get(state.activePanelId);
    return entry ? entry.flickity : null;
  },

  activatePanel: function ($section, panelId) {
    const sectionData = Shopify.theme.getSectionData($section);
    const state = $section.data('mxFeaturedCollections');
    if (!state) return;

    const $pills = $section.find('[data-mx-featured-collections-pill]');
    const $activePill = $pills.filter(`[data-panel-id="${panelId}"]`).first();
    if (!$activePill.length) return;

    $pills.removeClass('is-active').attr('aria-selected', 'false');
    $activePill.addClass('is-active').attr('aria-selected', 'true');

    const $panels = $section.find('[data-mx-featured-collections-panel]');
    $panels.hide();
    const $panel = $panels.filter(`[data-mx-featured-collections-panel="${panelId}"]`).first();
    $panel.show();
    if ($panel.length) {
      $panel[0].offsetWidth;
    }

    state.activePanelId = panelId;

    const shouldOverride = sectionData.section_link_override === true;
    if (!shouldOverride) {
      const url = $activePill.attr('data-collection-url');
      if (url) {
        $section.find('[data-mx-featured-collections-cta]').attr('href', url);
        const $headingLink = $section.find('.featured-collection__title a').first();
        if ($headingLink.length) $headingLink.attr('href', url);
      }
    } else if (sectionData.link_override) {
      $section.find('[data-mx-featured-collections-cta]').attr('href', sectionData.link_override);
      const $headingLink = $section.find('.featured-collection__title a').first();
      if ($headingLink.length) $headingLink.attr('href', sectionData.link_override);
    }

    if (sectionData.collection_style === 'slider') {
      this.initSliderForPanel($section, panelId);
      const flickity = this.getActiveFlickityInstance($section);
      if (flickity) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            flickity.resize();
            flickity.select(0, false, true);
            flickity.resize();
          });
        });
      }
    }
  },

  initSliderForPanel: function ($section, panelId) {
    const sectionData = Shopify.theme.getSectionData($section);
    const state = $section.data('mxFeaturedCollections');
    if (!state) return;
    if (state.instances.has(panelId)) return;

    const $panel = $section.find(`[data-mx-featured-collections-panel="${panelId}"]`).first();
    if (!$panel.length) return;

    const $slider = $panel.find('.slider-gallery').first();
    if (!$slider.length) return;
    if (typeof $slider.flickity !== 'function') return;

    const productsPerSlide = sectionData.products_per;
    const productsLimit = sectionData.products_limit;
    const isDesktop = window.innerWidth >= 768;

    let initialIndex = 0;
    if (sectionData.slider_align === 'left' && isDesktop) {
      initialIndex = Math.floor((productsPerSlide - 1) / 2);
    }

    const flickityOptions = {
      lazyLoad: 2,
      freeScroll: true,
      imagesLoaded: true,
      draggable: true,
      cellAlign: 'center',
      wrapAround: true,
      pageDots: false,
      contain: true,
      prevNextButtons: false,
      initialIndex: initialIndex,
      on: {
        ready: function () {
          const flkty = this;
          $slider.on('settle.flickity.mxFeaturedCollections', function () {
            flkty.resize();
          });

          const setUniformHeights = () => {
            let maxHeight = 0;
            $slider.find('.gallery-cell').each(function () {
              const $cell = $(this);
              $cell.css('height', '');
              maxHeight = Math.max(maxHeight, $cell.outerHeight());
            });
            $slider.find('.gallery-cell').css('height', `${maxHeight}px`);
            flkty.resize();
          };

          setUniformHeights();
          const debouncedResize = debounce(setUniformHeights, 150);
          $(window).on('resize.mxFeaturedCollections', debouncedResize);

          const entry = state.instances.get(panelId);
          if (entry) entry.resizeHandler = debouncedResize;
        }
      }
    };

    if (sectionData.navigation_old_style !== false) {
      flickityOptions.prevNextButtons = productsLimit > productsPerSlide;
      if (window.arrowShape) {
        flickityOptions.arrowShape = window.arrowShape;
      }
    }

    const flickityInstance = $slider.flickity(flickityOptions).data('flickity');

    state.instances.set(panelId, {
      $slider,
      flickity: flickityInstance,
      resizeHandler: null
    });
  },

  unload: function ($section) {
    const state = $section.data('mxFeaturedCollections');
    if (state) {
      state.instances.forEach((entry) => {
        if (entry && entry.resizeHandler) {
          $(window).off('resize.mxFeaturedCollections', entry.resizeHandler);
        }
        if (entry && entry.$slider && entry.$slider.length) {
          entry.$slider.off('.mxFeaturedCollections');
          try {
            entry.$slider.flickity('destroy');
          } catch (e) {}
        }
      });

      if (state.customCssEl) state.customCssEl.remove();
      if (state.customVisibilityEl) state.customVisibilityEl.remove();
    }

    $section.off('.mxFeaturedCollections');
    $section.removeData('mxFeaturedCollections');
  }
}

/******/ })()
;
